import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class LoginFlowLoaderService {
	private toggleLoader$ = new BehaviorSubject<boolean>(false);

	get loading$() {
		return this.toggleLoader$.asObservable();
	}

	toggleLoading(isLoading: boolean) {
		this.toggleLoader$.next(isLoading);
	}
}
